import Chip from '@mui/material/Chip';

interface ISelectProps {
    id: string,
    name: string,
    onDelete: (id: string) => void
}


const DeleteableChips = (props: ISelectProps) => {

    const ClearSelectedChip = (event: any) => {
        props.onDelete(props.id);
    }

    return (
        <Chip
            sx={{
                '& .MuiChip-deleteIcon': {
                    color: 'gray',
                    width: '0.8em',
                    height: '0.8em'
                },
            }}
            key={props.id}
            label={props.name}
            onDelete={ClearSelectedChip}
            onMouseDown={(event) => { event.stopPropagation() }}
        />
    );
}

export default DeleteableChips;
